module.exports = __webpack_public_path__ + "img/CM-BS-24-Volvo-Established.51e83e06.jpg";